import React, { createContext, useContext, useEffect } from 'react';
import { useSettingsStore } from '../store/settingsStore';

const ThemeContext = createContext({ isDark: false });

export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { darkMode } = useSettingsStore();

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <ThemeContext.Provider value={{ isDark: darkMode }}>
      {children}
    </ThemeContext.Provider>
  );
}